import {Storage} from "@/services/Storage";
import * as StompJs from "@stomp/stompjs";

export default {
    state: {
        websocket: null,
        isConnected: false,
        messages: [],

    },
    mutations: {
        SET_WEBSOCKET(state, websocket) {
            state.websocket = websocket;
        },
        SET_CONNECTED(state, status) {
            state.isConnected = status;
        },
        ADD_MESSAGE(state, message) {
            state.messages.push(message);
        },
    },
    actions: {
        connectWebSocket :async (context) => {
            let storeDB = await Storage.getCurrentStoreDB();
            if (context.state.isConnected || !storeDB) return;
            let brokerURL = securityApiWebsocket;
            const stompClient = new StompJs.Client({
                brokerURL,
                reconnectDelay: 5000, // Reconnect every 5 seconds if disconnected
                onConnect: (frame) => {
                    console.log('Connected: ' + frame);
                    context.commit('SET_CONNECTED', true);

                    // Subscribe to a topic
                    stompClient.subscribe(`/topic/pendingRequests/${storeDB}`, ({body}) => {
                        let requests = JSON.parse(body)
                        context.commit(`setPendingRequests`,requests);
                    });
                },
                onStompError: (frame) => {
                    console.error('Broker error:', frame.headers['message']);
                    console.error('Details:', frame.body);
                },
                onWebSocketError: (error) => {
                    console.error('WebSocket error:', error);
                },
            });

            stompClient.activate(); // Start the connection
        },
        disconnectWebSocket({ commit, state }) {
            if (state.websocket) {
                state.websocket.close();
                commit("SET_WEBSOCKET", null);
                commit("SET_CONNECTED", false);
            }
        },
    },
    getters: {
        isConnected: (state) => state.isConnected,
        messages: (state) => state.messages,
    },
};
